import * as React from 'react';
import Box from "@mui/material/Box";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {TextField} from "@mui/material";
import "dayjs/locale/pl";
import {DEF} from "../const";
import {DatePicker} from "@mui/x-date-pickers";
import clsx from "clsx";
import css from './DateRangePicker.module.css'
import dayjs from "dayjs";
import 'dayjs/locale/pl';


export const DateRangePicker = ({
                                    setDateFrom,
                                    setDateTo,
                                    dateFrom,
                                    dateTo,
                                    setDateError,
                                }) => {
    const locale = 'pl'

    const handleDateFromChange = (newValue) => {
        if (newValue.isAfter(dateTo)) {
            setDateError('Próbujesz ustawić datę początku po dacie końcowej.');
            return false;
        } else {
            setDateError('');
            setDateFrom(newValue);
            return true;
        }
    };

    const handleDateToChange = (newValue) => {
        if (newValue.isBefore(dateFrom)) {
            setDateError('Próbujesz ustawić datę końca okresu przed datą początkową.');
            return false;
        } else {
            setDateError('');
            setDateTo(newValue);
            return true;
        }
    };

    return (
        <Box className={clsx(css.dateRangePicker)}>
            <LocalizationProvider dateAdapter={AdapterDayjs} locale={locale}>
                <Box className={clsx(css.row)}>
                    <DatePicker className={clsx(css.dateFrom)}
                                label="Data od"
                                inputFormat={DEF.DATE_FORMAT}
                                format={DEF.DATE_FORMAT}
                                adapterLocale={locale}
                                defaultValue={dayjs(dateFrom)}
                                onChange={(newValue) => {
                                    return handleDateFromChange(newValue);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                    />
                                )}
                    />

                    <DatePicker className={clsx(css.dateTo)}
                                label="Data do"
                                inputFormat={DEF.DATE_FORMAT}
                                format={DEF.DATE_FORMAT}
                                adapterLocale={locale}
                                defaultValue={dayjs(dateTo)}
                                onChange={(newValue) => {
                                    return handleDateToChange(newValue);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                    />
                                )}
                    />
                </Box>
            </LocalizationProvider>
        </Box>
    );
};

export default DateRangePicker;
